import request from "@/api/request";
import { Visit } from "@/interfaces/Visit";

class VisitService {
  static async trackVisit(): Promise<Visit> {
    const urlParams = new URLSearchParams(location.search);
    const requestParams: { [key: string]: string } = { referer: document.referrer };

    for (const [key, value] of urlParams.entries()) {
      requestParams[key] = value;
    }

    return request.get("/track/visit", requestParams);
  }
}

export default VisitService;
